import { ApiV3 } from '../../commonv3/api/ApiV3';

const baseHost = process.env.REST_API_BASE_URL || `${location.protocol}//${location.host}`;
export const MainV3ApiBase = new ApiV3(`${baseHost}/api/v3`);

export const CommonsV1ApiBase = new ApiV3(`${baseHost}/api/commons/v1`);
